if (!customElements.get('sticky-product-atc')) {
  customElements.define(
    'sticky-product-atc',
    class StickyProductAtc extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.mainButton = this.productInfo?.querySelector('.product-form__submit');
        this.mainForm = this.mainButton?.closest('form');
        this.stickyButton = this.querySelector('[data-sticky-atc-button]');
        this.stickyLabel = this.querySelector('[data-sticky-atc-label]');
        this.stickyPrice = this.querySelector('[data-sticky-atc-price]');
        this.stickyImage = this.querySelector('.product-sticky-atc__image');

        if (!this.mainButton || !this.mainForm || !this.stickyButton) {
          this.hidden = true;
          return;
        }

        this.hidden = false;
        this.syncButton();
        this.observeMainButton();
        this.observeProductState();

        this.stickyButton.addEventListener('click', () => {
          if (!this.mainButton.disabled) this.mainForm.requestSubmit(this.mainButton);
        });

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data?.sectionId !== this.productInfo.dataset.section) return;
            this.syncPrice();
            this.syncImage(event.data.variant);
            this.syncButton();
          });
        }
      }

      disconnectedCallback() {
        this.intersectionObserver?.disconnect();
        this.stateObserver?.disconnect();
        this.variantUnsubscriber?.();
      }

      observeMainButton() {
        this.intersectionObserver = new IntersectionObserver(([entry]) => {
          const hasScrolledPastButton = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.classList.toggle('is-visible', hasScrolledPastButton);
          this.setAttribute('aria-hidden', String(!hasScrolledPastButton));
        });
        this.intersectionObserver.observe(this.mainButton);
      }

      observeProductState() {
        this.stateObserver = new MutationObserver(() => {
          this.syncButton();
          this.syncPrice();
        });
        this.stateObserver.observe(this.mainButton, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled'],
          childList: true,
          subtree: true,
          characterData: true,
        });

        const mainPrice = this.productInfo.querySelector('[id^="price-"]');
        if (mainPrice) this.stateObserver.observe(mainPrice, { childList: true, subtree: true, characterData: true });
      }

      syncButton() {
        const mainLabel = this.mainButton.querySelector('span')?.textContent?.trim();
        if (mainLabel) this.stickyLabel.textContent = mainLabel;
        this.stickyButton.disabled = this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true';
      }

      syncPrice() {
        const mainPrice = this.productInfo.querySelector('[id^="price-"] .price');
        if (mainPrice && this.stickyPrice) this.stickyPrice.innerHTML = mainPrice.outerHTML;
      }

      syncImage(variant) {
        const source = variant?.featured_media?.preview_image?.src;
        if (source && this.stickyImage) this.stickyImage.src = source;
      }
    }
  );
}
